import React, { useContext, useEffect } from 'react';
import {
  ComponentFactory,
  ComponentParams,
  ComponentRendering,
  Placeholder,
  Field,
  RichText,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { IoPrintOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { APIWebstoreContext } from '../../../context/globalContext';

export type OrderConfirmationProps = {
  fields: {
    Title: Field<string>;
    ConfirmationText: Field<string>;
    ConfirmationTextNoEULA: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};
interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const OrderConfirmation = (props: OrderConfirmationProps & Props): React.JSX.Element => {
  const { fields, rendering } = props;
  const { state } = useContext(APIWebstoreContext);

  function replaceText(): Field<string> {
    let OrderConfirmationText = state?.hasEULA
      ? fields?.ConfirmationText?.value
      : fields?.ConfirmationTextNoEULA?.value;
    OrderConfirmationText = OrderConfirmationText.replace('##EMAIL_ID##', state?.userEmail || '');
    OrderConfirmationText = OrderConfirmationText.replace(
      '##ORDER_NUMBER##',
      state?.lastOrderId || ''
    );
    fields.ConfirmationText.value = OrderConfirmationText;
    return fields.ConfirmationText;
  }

  useEffect(() => {
    window.history.replaceState(null, 'API WebStore | Order history', '/orders/history');
  }, []);

  return (
    <div className="centerContainer">
      <div className="orderConfirmationSection">
        <div className="orderConfirmationHeader">
          <h1>{fields?.Title?.value}</h1>
          <div className="orderSummaryEditCart">
            <IoPrintOutline></IoPrintOutline>

            <Link
              to={
                state?.lastOrderId !== ''
                  ? `/orders/unifiedreceipt?referenceNo=${state?.lastOrderId}`
                  : '/orders/history'
              }
              id="OrderHistory"
              target="_blank"
            >
              Print Receipt
            </Link>
          </div>
        </div>

        <div className="orderConfirmationContent">
          <RichText className="orderConfirmationRichText" field={replaceText()} />
        </div>
        <Placeholder name="continue_shopping" rendering={rendering} />
      </div>
    </div>
  );
};

export default OrderConfirmation;
